import {extendTheme} from '@chakra-ui/core';

const theme = extendTheme({
  colors: {
    gray: {
      900: '#011627',
      800: '#12293d',
      700: '#203a52',
      600: '#2f4c67',
      500: '#3b5877',
      400: '#566f8c',
      300: '#7187a1',
      200: '#96a8bf',
      100: '#baccdf',
      50: '#e1eafb'
    },
    purple: {
      900: '#181ea3',
      800: '#4e23b2',
      700: '#6426ba',
      600: '#7a29c3',
      500: '#8a2bc9',
      400: '#9c48d4',
      300: '#af67df',
      200: '#c792ea',
      100: '#ddbdf2',
      50: '#f2e5f9'
    }
  }
});

export default theme;
